module.exports = __webpack_public_path__ + "static/media/Cashflow.c70e26a8.png";